export default __webpack_public_path__ + "static/media/695.aa75125f.png";